// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"76ab40b9","514":"cf008d42","803":"4679c814"}[chunkId] + ".chunk.css";
};